import {map} from 'lodash'
import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import '@/store/api/staff-member/typedefs'
import api from '@/store/api/staff-member'
// Modules
import logs from './logs'
import staffMember from './staff-member'
import roles from './roles'

const initialState = () => ({
    groups: {
        data: [],
        pagination: {}
    },
    staffMembers: {
        data: [],
        pagination: {}
    },
    search: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        groups: state => state.groups,
        staffMembers: state => state.staffMembers.data.map(staffMember => ({
            ...staffMember,
            group_ids: map(staffMember.groups, 'id'),
            full_name: `${staffMember.first_name} ${staffMember.last_name}`
        })),
        staffMembersSearch: state => state.search,
        pagination: state => state.staffMembers.pagination
    },
    actions: {
        /**
         * @param {ListQuery} params
         * @returns {Promise<*>}
         */
        listStaffMembers: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listStaffMembers(params)
                commit(mutationTypes.SET_STAFF_MEMBERS, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {ListQuery} params
         * @returns {Promise<*>}
         */
        searchStaffMembers: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listStaffMembers(params)
                commit(mutationTypes.SET_STAFF_MEMBERS_SEARCH, response.data)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {SearchQuery} params
         * @returns {Promise<*>}
         */
        searchGroups: async ({commit, dispatch}, params) => {
            try {
                const response = await api.searchGroups(params)
                commit(mutationTypes.SET_GROUPS, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetGroups: ({commit}) => commit(mutationTypes.RESET_GROUPS),
        resetStaffMembers: ({commit}) => commit(mutationTypes.RESET_STAFF_MEMBERS),
        setStaffMembers: ({commit}, data) => commit(mutationTypes.SET_STAFF_MEMBERS, data)
    },
    modules: {
        logs,
        staffMember,
        roles
    },
    mutations: {
        [mutationTypes.RESET_GROUPS]: (state) => Object.assign(state.groups, initialState().groups),
        [mutationTypes.RESET_STAFF_MEMBERS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_GROUPS]: (state, data) => state.groups = data,
        [mutationTypes.SET_STAFF_MEMBERS_SEARCH]: (state, data) => state.search = data.data,
        [mutationTypes.SET_STAFF_MEMBERS]: (state, data) => {
            const {data: staffMembers, pagination} = data

            state.staffMembers = {
                data: staffMembers,
                pagination: mapLegacyPagination(pagination)
            }
        }
    }
}
